<template>
    <div><slot name="activator" v-bind="{ attrs: { loading }, on: { click } }" /></div>
</template>

<script>
import { initExpoEmployer } from "@/assets/variables";
import api from "@/api";

export default {
    props: {
        value: { type: Object, default: initExpoEmployer },
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        async click() {
            const go = confirm("참여신청을 취소하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.company.expo.employers.delete({ _id: this.value._id });
                this.$emit("search");
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>